import { buttonBaseClasses, tabClasses, type Theme } from "@mui/material"
import { TabsTheme } from "core/themes/src/definitions/components.types"

export const createTabsTheme = (theme: Theme): TabsTheme => ({
    styleOverrides: {
        root: {
            [theme.breakpoints.up("xl")]: {
                [`.${buttonBaseClasses.root}.${tabClasses.root}`]: {
                    fontSize: theme.typography.fontSize + 2,
                    padding: "12px 14px",
                },
            },
        },
    },
    variants: [
        {
            props: { layout: "buttons" },
            style: {
                [`& .${buttonBaseClasses.root}.${tabClasses.selected}`]: {
                    translate: "unset",
                },
            },
        },
    ],
})
